import React from "react"
import Image from "next/image"
import { BlokImage } from "../types"
import { readImage } from "@/app/utils/read-image"

export interface IHowMuchQuote {
  blok: {
    quote: string
    image: BlokImage
  }
}

const HowMuchQuote: React.FC<IHowMuchQuote> = ({ blok }) => (
  <div className="mx-auto text-center flex justify-center my-8 md:my-10 px-4">
    <div className="py-2 md:py-10">
      <div>
        <blockquote className="text-[24px] mb-2 md:text-[28px] font-roboto inline-flex justify-center items-start md:items-center min-h-18 leading-[50px] md:leading-8 md:mb-8">
          {blok.quote}
        </blockquote>
      </div>
      <div className="mx-auto inline-flex justify-center align-center ">
        {blok.image && blok.image?.filename && (
          <Image
            src={readImage(blok.image)}
            alt={blok.image.alt || "Quote image"}
            className="w-20 h-10 object-scale-down object-center"
            height={80}
            width={172}
          />
        )}
      </div>
    </div>
  </div>
)

export default HowMuchQuote
